<template>
    <b-modal
        :id="'update-default-skill-tree-' + skillTreeIn.id"
        :title="$t('skill_tree.edit_set')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @show="onShow"
        modal-class="apprentice-default-modal">
        <label>{{ $t('common.name') }}</label>
        <b-form-input v-model="name"></b-form-input>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-default-skilltree-update-modal-component',
    props: ['skillTreeIn'],
    data() {
        return {
            name: this.skillTreeIn.name,
        };
    },
    methods: {
        onOk() {
            let data = {
                name: this.name,
            };

            this.alert.saving();

            this.axios.post(this.routes.defaultSkillTreeUpdate(this.skillTreeIn.id), data).then(
                (response) => {
                    this.skillTreeIn.update(response.data);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.name = this.skillTreeIn.name;
        },
    },
};
</script>

<style scoped lang="scss">
.selected-skill-tree-previews {
    .selected-skill {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        flex: 1;
        margin-left: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        margin-right: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one');

        .title {
            display: inline-flex;
            flex-grow: 1;
            font-size: 1.3125rem;
            font-weight: $font-weight-bold;
            color: $primary;

            .icon {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        .school-years {
            .school-year {
                padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'twenty-one');
                border-bottom: 3px dotted $border-color;

                label {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 0;
                }
            }
        }

        .btn-remove-skill {
            font-size: $default-font-size;
            margin-top: map-get($grid-gutter-spacing, 'twenty-one');
            display: flex;
            align-items: center;
            flex-direction: row;
            align-self: flex-end;

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        &:nth-child(even) {
            background-color: $secondary-background-color;
        }
    }
}
</style>
